import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';

import './orderStatusModal.less';

const STATUS = {
  IN_PROGRESS: 1,
  DONE: 2,
  CANCELED: 3,
};

class OrderStatusModal extends React.Component {
  onStatusChange = value => {
    const { onStatusChange, closeModal, orderId } = this.props;

    onStatusChange(orderId, value);
    closeModal();
  }

  onClose = () => {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const { open, orderId } = this.props;

    // prevent of duplicate modal render (material ui bug)
    if (document.querySelectorAll('.order-status-modal').length) {
      return null;
    }

    return (
      <Dialog onClose={this.onClose} open={open} className="order-status-modal">
        <DialogTitle id="simple-dialog-title">
          Wybierz status dla zamówienia o id:
          {' '}
          {orderId}
        </DialogTitle>
        <List>
          <ListItem button onClick={() => this.onStatusChange(STATUS.IN_PROGRESS)}>
            <ListItemAvatar>
              <Avatar>
                <AutorenewIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="W realizacji" />
          </ListItem>

          <ListItem button onClick={() => this.onStatusChange(STATUS.DONE)}>
            <ListItemAvatar>
              <Avatar>
                <DoneIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Zrealizowane" />
          </ListItem>

          <ListItem button onClick={() => this.onStatusChange(STATUS.CANCELED)}>
            <ListItemAvatar>
              <Avatar>
                <CloseIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Anulowane" />
          </ListItem>
        </List>
      </Dialog>
    );
  }
}

OrderStatusModal.propTypes = {
  onStatusChange: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  orderId: PropTypes.string.isRequired,
};

export default OrderStatusModal;
